import { render } from "./top_bar.vue?vue&type=template&id=85d71644"
import script from "./top_bar.vue?vue&type=script&lang=js"
export * from "./top_bar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__